export class EmployeeFilters {
  constructor(obj) {
    this.academicDegreeId = obj?.academicDegreeId || null
    this.isActual = obj?.isActual || null
    this.departmentId = obj?.departmentId || null
    this.fullName = obj?.fullName || null
    this.dutyId = obj?.dutyId || null
    this.login = obj?.login || null
    this.personTitleId = obj?.personTitleId || null
    this.salaryRateId = obj?.salaryRateId || null
  }

  getForAPI() {
    return {
      academicDegreeId: this.academicDegreeId || null,
      isActual: typeof this.isActual === 'number' ? Boolean(this.isActual) : null,
      departmentId: this.departmentId || null,
      fullName: this.fullName || null,
      dutyId: this.dutyId,
      login: this.login || null,
      personTitleId: this.personTitleId || null,
      salaryRateId: this.salaryRateId || null
    }
  }
}
